import api from './axios';

const BASE = '/balance-sheet';

/** filters: { entryType, category, dateFrom, dateTo, completedSales, advancePayments } → { entries: Page, totals } */
export const getBalanceSheet = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const createEntry = (data) => api.post(`${BASE}/entries`, data);

export const updateEntry = (id, data) => api.put(`${BASE}/entries/${id}`, data);

export const deleteEntry = (id) => api.delete(`${BASE}/entries/${id}`);
